/**
 * 组织接口秘钥实体
 */

import { useState } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Select,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    rff,
} from '../../incs/FunHelper';

import CNF from '../../incs/Config';

const MODULENAME = '组织秘钥';

const Option = Select.Option;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [serviceCode, setServiceCode] = useState(null);
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setServiceCode(null);
        setDescription('');
    };


    const ok = () => {
        if (serviceCode === null) {
            message.error('服务代码不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: `${CNF.api}org/apikeys`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'service_code': serviceCode,
                'description': description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={500}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}服务代码</Col>
                    <Col span={24}>
                        <Select
                            placeholder='服务代码'
                            value={serviceCode}
                            style={{ width: '100%' }}
                            onChange={(value) => setServiceCode(value)}
                        >
                            {
                                props.serviceCodes && props.serviceCodes.map((item) => {
                                    return <Option key={item} value={item}>{item}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里...'
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity